module.exports = __webpack_public_path__ + "img/lost.7e09b993.png";